import { Fragment, type ComponentProps, type PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import IcChevronRightBold from 'src/assets/images/icChevronRightBold.svg';
const Container = styled.h2`
  margin: 0;

  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 18px;
  font-weight: 700;

  color: ${({
  theme
}) => theme.color.content10};

  padding: 24px 24px 8px 24px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 12px 16px;
  }
`;
const Button = styled.button`
  cursor: pointer;
  outline: none;
  background: none;
  border: none;
  appearance: none;

  font-size: inherit;
  font-weight: inherit;

  display: flex;
  align-items: center;
  gap: 8px;

  color: inherit;
`;
const MoreIcon = styled(IcChevronRightBold)`
  width: 14px;
  height: 14px;

  color: ${({
  theme
}) => theme.color.content7};

  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
interface Props extends Pick<ComponentProps<'div'>, 'className'>, PropsWithChildren {
  onClick?: () => void;
}
const SectionTitle = ({
  onClick,
  children,
  ...props
}: Props) => {
  const ChildComponent = onClick ? Button : Fragment;
  const childProps = onClick ? {
    type: 'button',
    onClick
  } as ComponentProps<'button'> : {};
  return <Container {...props} data-sentry-element="Container" data-sentry-component="SectionTitle" data-sentry-source-file="SectionTitle.tsx">
      <ChildComponent {...childProps} data-sentry-element="ChildComponent" data-sentry-source-file="SectionTitle.tsx">
        <span>{children}</span>
        {!!onClick && <MoreIcon />}
      </ChildComponent>
    </Container>;
};
export default SectionTitle;